(function () {
  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function formatCurrency(value, currencyCode, currencySymbol) {
    var amount = toNumber(value, 0);

    if (typeof Intl !== 'undefined' && currencyCode) {
      try {
        var hasDecimals = Math.round(amount) !== amount;
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode,
          minimumFractionDigits: hasDecimals ? 2 : 0,
          maximumFractionDigits: hasDecimals ? 2 : 0,
        }).format(amount);
      } catch (error) {
        // Fall through to the symbol-based fallback.
      }
    }

    return (currencySymbol || '$') + String(Math.round(amount));
  }

  function createHiddenInput(name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    return input;
  }

  function replaceHiddenInputs(container, entries) {
    if (!container) return;

    container.replaceChildren();
    entries.forEach(function (entry) {
      if (!entry.name || entry.value === '' || entry.value == null) return;
      container.appendChild(createHiddenInput(entry.name, String(entry.value)));
    });
  }

  function updatePriceUI(root) {
    var priceRoot = root.querySelector('[data-dlux-price-range]');
    if (!priceRoot) return;

    var minInput = priceRoot.querySelector('[data-dlux-price-min-input]');
    var maxInput = priceRoot.querySelector('[data-dlux-price-max-input]');
    var label = priceRoot.querySelector('[data-dlux-price-label]');
    var track = priceRoot.querySelector('[data-dlux-price-track]');

    if (!minInput || !maxInput || !label || !track) return;

    var minBound = toNumber(priceRoot.dataset.min, 0);
    var maxBound = toNumber(priceRoot.dataset.max, minBound);
    var minValue = toNumber(minInput.value, minBound);
    var maxValue = toNumber(maxInput.value, maxBound);

    if (minValue > maxValue) {
      minValue = maxValue;
      minInput.value = String(minValue);
    }

    if (maxValue < minValue) {
      maxValue = minValue;
      maxInput.value = String(maxValue);
    }

    var range = Math.max(maxBound - minBound, 1);
    var minPercent = ((minValue - minBound) / range) * 100;
    var maxPercent = ((maxValue - minBound) / range) * 100;
    track.style.left = minPercent + '%';
    track.style.width = Math.max(maxPercent - minPercent, 0) + '%';

    label.textContent =
      formatCurrency(minValue, root.dataset.currencyCode, root.dataset.currencySymbol) +
      ' - ' +
      formatCurrency(maxValue, root.dataset.currencyCode, root.dataset.currencySymbol);
  }

  /* ── Checkbox dropdown helpers ────────────────────────────── */

  function getCheckedValues(root, type) {
    var checks = root.querySelectorAll('[data-dlux-filter-check="' + type + '"]');
    var values = [];
    checks.forEach(function (cb) {
      if (cb.checked) values.push(cb.value);
    });
    return values;
  }

  function updateDropdownLabel(dropdown, placeholder) {
    var label = dropdown.querySelector('[data-dlux-dropdown-label]');
    if (!label) return;
    var checks = dropdown.querySelectorAll('input[type="checkbox"]');
    var selected = [];
    checks.forEach(function (cb) {
      if (cb.checked) {
        var text = cb.parentElement.querySelector('span');
        if (text) selected.push(text.textContent.trim());
      }
    });
    label.textContent = selected.length ? selected.join(', ') : placeholder;
  }

  function toggleDropdown(dropdown, forceOpen) {
    var panel = dropdown.querySelector('[data-dlux-dropdown-panel]');
    var trigger = dropdown.querySelector('[data-dlux-dropdown-trigger]');
    if (!panel || !trigger) return;

    var isOpen = typeof forceOpen === 'boolean' ? forceOpen : panel.hidden;
    panel.hidden = !isOpen;
    trigger.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      // Close other open dropdowns
      document.querySelectorAll('[data-dlux-filter-dropdown]').forEach(function (other) {
        if (other !== dropdown) toggleDropdown(other, false);
      });
    }
  }

  /* ── Sync hidden inputs ───────────────────────────────────── */

  function syncHiddenInputs(root) {
    var concernParam = root.dataset.concernParam;
    var stepParam = root.dataset.stepParam;
    var vendorParam = root.dataset.vendorParam;
    var priceMinParam = root.dataset.priceMinParam;
    var priceMaxParam = root.dataset.priceMaxParam;
    var priceRoot = root.querySelector('[data-dlux-price-range]');
    var tagHost = root.querySelector('[data-dlux-hidden-tags]');
    var brandHost = root.querySelector('[data-dlux-hidden-brand]');
    var priceHost = root.querySelector('[data-dlux-hidden-price]');
    var activeCount = 0;

    // Collect all checked concern + step values
    var concernValues = getCheckedValues(root, 'concern');
    var stepValues = getCheckedValues(root, 'step');
    var tagEntries = concernValues
      .map(function (v) {
        return { name: concernParam, value: v };
      })
      .concat(
        stepValues.map(function (v) {
          return { name: stepParam, value: v };
        })
      );

    replaceHiddenInputs(tagHost, tagEntries);
    if (concernValues.length) activeCount += 1;
    if (stepValues.length) activeCount += 1;

    var brandValues = getCheckedValues(root, 'brand');
    var brandEntries = vendorParam
      ? brandValues.map(function (v) {
          return { name: vendorParam, value: v };
        })
      : [];
    replaceHiddenInputs(brandHost, brandEntries);
    if (brandValues.length) activeCount += 1;

    if (priceRoot && priceMinParam && priceMaxParam) {
      var minBound = toNumber(priceRoot.dataset.min, 0);
      var maxBound = toNumber(priceRoot.dataset.max, minBound);
      var minInput = priceRoot.querySelector('[data-dlux-price-min-input]');
      var maxInput = priceRoot.querySelector('[data-dlux-price-max-input]');
      var minValue = minInput ? toNumber(minInput.value, minBound) : minBound;
      var maxValue = maxInput ? toNumber(maxInput.value, maxBound) : maxBound;
      var priceEntries = [];

      if (minValue !== minBound) priceEntries.push({ name: priceMinParam, value: minValue });
      if (maxValue !== maxBound) priceEntries.push({ name: priceMaxParam, value: maxValue });
      if (priceEntries.length) activeCount += 1;

      replaceHiddenInputs(priceHost, priceEntries);
    } else {
      replaceHiddenInputs(priceHost, []);
    }

    var clearButton = root.querySelector('[data-dlux-clear]');
    if (clearButton) clearButton.hidden = activeCount === 0;
  }

  function notifyForm(root) {
    var form = root.closest('form');
    if (!form) return;
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function onRangeInput(root, event) {
    var priceRoot = root.querySelector('[data-dlux-price-range]');
    if (!priceRoot) return;

    var minInput = priceRoot.querySelector('[data-dlux-price-min-input]');
    var maxInput = priceRoot.querySelector('[data-dlux-price-max-input]');
    if (!minInput || !maxInput) return;

    var minValue = toNumber(minInput.value, 0);
    var maxValue = toNumber(maxInput.value, 0);

    if (event.target === minInput && minValue > maxValue) {
      maxInput.value = minInput.value;
    } else if (event.target === maxInput && maxValue < minValue) {
      minInput.value = maxInput.value;
    }

    updatePriceUI(root);
    syncHiddenInputs(root);
    notifyForm(root);
  }

  function onSelectChange(root) {
    updatePriceUI(root);
    syncHiddenInputs(root);
    notifyForm(root);
  }

  var PLACEHOLDERS = { concern: 'Skin Concern', step: 'Routine Step', brand: 'Brand' };

  function onClear(root) {
    // Uncheck all checkbox filters
    root.querySelectorAll('[data-dlux-filter-check]').forEach(function (cb) {
      cb.checked = false;
    });
    // Update dropdown labels
    root.querySelectorAll('[data-dlux-filter-dropdown]').forEach(function (dd) {
      var type = dd.dataset.dluxFilterDropdown;
      updateDropdownLabel(dd, PLACEHOLDERS[type] || '');
    });

    // Reset dropdown search inputs and re-show all items
    root.querySelectorAll('[data-dlux-dropdown-search]').forEach(function (s) {
      s.value = '';
    });
    root.querySelectorAll('[data-dlux-dropdown-item]').forEach(function (i) {
      i.hidden = false;
    });

    var priceRoot = root.querySelector('[data-dlux-price-range]');

    if (priceRoot) {
      var minInput = priceRoot.querySelector('[data-dlux-price-min-input]');
      var maxInput = priceRoot.querySelector('[data-dlux-price-max-input]');
      if (minInput) minInput.value = priceRoot.dataset.min || '0';
      if (maxInput) maxInput.value = priceRoot.dataset.max || '0';
    }

    updatePriceUI(root);
    syncHiddenInputs(root);
    notifyForm(root);
  }

  function mount(root) {
    if (root.dataset.dluxMounted === 'true') return;
    root.dataset.dluxMounted = 'true';

    // ── Checkbox dropdown triggers ──
    root.querySelectorAll('[data-dlux-filter-dropdown]').forEach(function (dropdown) {
      var trigger = dropdown.querySelector('[data-dlux-dropdown-trigger]');
      var type = dropdown.dataset.dluxFilterDropdown;
      var placeholder = PLACEHOLDERS[type] || '';

      // Set initial label from pre-checked boxes
      updateDropdownLabel(dropdown, placeholder);

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleDropdown(dropdown);
        });
      }

      // Checkbox change → sync + submit
      dropdown.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          updateDropdownLabel(dropdown, placeholder);
          syncHiddenInputs(root);
          notifyForm(root);
        });
      });

      // Searchable dropdown: filter items live
      var search = dropdown.querySelector('[data-dlux-dropdown-search]');
      if (search) {
        search.addEventListener('input', function (e) {
          e.stopPropagation();
          var q = search.value.trim().toLowerCase();
          dropdown.querySelectorAll('[data-dlux-dropdown-item]').forEach(function (item) {
            var label = item.dataset.label || '';
            item.hidden = q !== '' && label.indexOf(q) === -1;
          });
        });
        search.addEventListener('change', function (e) {
          e.stopPropagation();
        });
        search.addEventListener('click', function (e) {
          e.stopPropagation();
        });
        search.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            e.stopPropagation();
            if (search.value) {
              search.value = '';
              search.dispatchEvent(new Event('input'));
            } else {
              toggleDropdown(dropdown, false);
            }
          }
        });
      }
    });

    // Close dropdowns on outside click
    document.addEventListener('click', function (e) {
      root.querySelectorAll('[data-dlux-filter-dropdown]').forEach(function (dd) {
        if (!dd.contains(e.target)) toggleDropdown(dd, false);
      });
    });

    // Close dropdowns on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        root.querySelectorAll('[data-dlux-filter-dropdown]').forEach(function (dd) {
          toggleDropdown(dd, false);
        });
      }
    });

    // ── Sort select ──
    root.querySelectorAll('[data-dlux-filter-control="sort"]').forEach(function (select) {
      select.addEventListener('change', function () {
        onSelectChange(root);
      });
    });

    root
      .querySelectorAll('[data-dlux-price-min-input], [data-dlux-price-max-input]')
      .forEach(function (input) {
        input.addEventListener('input', function (event) {
          onRangeInput(root, event);
        });
        input.addEventListener('change', function (event) {
          onRangeInput(root, event);
        });
      });

    var clearButton = root.querySelector('[data-dlux-clear]');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        onClear(root);
      });
    }

    updatePriceUI(root);
    syncHiddenInputs(root);
  }

  function mountAll(scope) {
    var searchRoot = scope && scope.querySelectorAll ? scope : document;
    searchRoot.querySelectorAll('[data-dlux-collection-filters]').forEach(mount);
  }

  window.DluxCollectionFilters = {
    mountAll: mountAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll(document);
    });
  } else {
    mountAll(document);
  }
})();
